<template>

  <div class="my-team-tree">
      <b-row class="my-team-tree__search">
          <b-col col lg="4" cols="12">
              <dropdown-component
                      :autocomplete="true"
                      :searchUrl="api.user.tree.search"
                      :onElementClick="loadTree">
              </dropdown-component>
          </b-col>
      </b-row>

      <div v-for="(level, levelIndex) in tree" class="my-team-tree__level">
          <my-team-tree-level :levelIndex="levelIndex" :items="level"></my-team-tree-level>
      </div>

      <div class="my-team-tree__buttons">
          <a class="button--primary" @click="backToPreviousLevel()" :disabled="!areButtonsAvailable">Back to previous level</a>
          <a class="button--primary" @click="treeReset()" :disabled="!areButtonsAvailable">Tree reset</a>
      </div>
  </div>

</template>

<script>
    import MyTeamTreeLevel from './my-team-tree-level/MyTeamTreeLevel.vue';

    export default {
        dependencies: ['api'],
        mounted: function() {
            if(!this.tree.length) {
                this.$store.commit('SetPath', { login: this.getUser.login, index: 0 });
                this.$store.commit('InsertLevel', {
                    level: [
                        {
                            email: this.getUser.email,
                            login: this.getUser.login
                        }
                    ],
                    levelIndex: -1
                });
            }
        },
        components: { MyTeamTreeLevel },
        computed: {
            tree () {
                return this.$store.getters.getTree
            },
            isLoading () {
                return this.$store.getters.getTreeLoading
            },
            getUser () {
                return this.$store.getters.user;
            },
            areButtonsAvailable () {
                return this.tree.length > 2;
            }
        },
        methods: {
            loadTree(user) {

                // Clear current tree
                this.$store.commit('BackToLevel', { levelIndex: 1 });

                // Update view value
                this.selected = user.login;

                // Get path
                this.$http.get(this.api.user.tree.pathFor(user))
                    .then((path) => {
                        let _promisesArray = [];
                        path.data.data.forEach((login, key) => {
                            _promisesArray.push(this.$http.get(this.api.user.tree.frontliners(login)));
                        });

                        // Resolve all promises
                        Promise.all(_promisesArray)
                            .then((tree) => {
                                tree.forEach((level, key) => {
                                    // Remove vue observer, not necessary
                                    let parsedLevel = JSON.parse(JSON.stringify( level.data.data ));
                                    this.$store.commit('InsertLevel', {
                                        level: level.data.data,
                                        levelIndex: key
                                    });

                                    // Do not set path for last child
                                    if(tree.length > key + 1) {
                                        this.$store.commit('SetPath', {
                                            login: path.data.data[key + 1],
                                            levelIndex: key + 1,
                                            index: parsedLevel.findIndex(frontliner => frontliner.login === path.data.data[key + 1]) });
                                    }
                                });
                            })
                    });
            },
            backToPreviousLevel () {
                if(this.tree.length - 1 > 1) {
                    this.$store.commit('BackToLevelWithoutPath', { levelIndex: this.tree.length - 1 });
                }
            },
            treeReset () {
                this.$store.commit('BackToLevelWithoutPath', { levelIndex: 2 });
            }
        },
        beforeDestroy () {
            this.$store.commit('ClearTree');
        }
    }
</script>

<style lang="scss">

    @import '../../../../../../assets/scss/_colors.scss';

    .my-team-tree {
        &__search {
            display: flex;
            justify-content: flex-end;
            align-items: flex-end;
            margin-bottom: 10px;
        }
        &__buttons {
            margin-top: 20px;
            float: right;
            a {
                margin-top: 5px;
                &[disabled] {
                    background-color: $gray;
                    cursor: default;
                }
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/layout/partials/section/content/my-team/MyTeamTree.vue